//
//
//
//

export default {
  name: 'NoPageRoute'
};